var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mess",style:(_vm.position)},[_c('div',{staticClass:"side-ammo",style:(_vm.advancedStyle)}),_c('div',{staticClass:"master-ammo"}),_c('div',{staticClass:"side-ammo",style:(_vm.advancedStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }